module.exports = __webpack_public_path__ + "img/copy.8155e439.svg";